var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternPricing1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 833.74 1275.19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m325.13 967.82-85.13 85.19 85.13 85.19 85.12-85.19z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.44 1022.68h-60.62v60.66h60.62z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m776.02 974.68-57.72 57.76 57.72 57.76 57.72-57.76z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m796.57 1011.88h-41.1v41.13h41.1z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.23,
    cy: 224.76,
    opacity: 0.08,
    rx: 77.72,
    ry: 77.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.73 134.3a91.92 91.92 0 0 1 -91.81 92 91.93 91.93 0 0 1 91.81-92z",
    opacity: 0.05,
    transform: "translate(82.76 -1.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.56 223.66v2.68h-2.67a89.25 89.25 0 0 1 -89.14-89.34v-2.7h2.68a89.25 89.25 0 0 1 89.13 89.36z",
    opacity: 0.05,
    transform: "translate(82.76 -1.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.89 227.25h2.67v2.68a89.24 89.24 0 0 1 -89.13 89.35h-2.68v-2.68a89.24 89.24 0 0 1 89.14-89.35z",
    opacity: 0.05,
    transform: "translate(82.76 -1.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.73 316.6v2.68h-2.67a89.24 89.24 0 0 1 -89.14-89.35v-2.68h2.68a89.24 89.24 0 0 1 89.13 89.35z",
    opacity: 0.05,
    transform: "translate(82.76 -1.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.69,
    cy: 1194.35,
    opacity: 0.08,
    r: 67.04
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.76 -1.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 1235.41a77.48 77.48 0 0 1 26.53-106.29l2-1.19 1.19 2a77.46 77.46 0 0 1 -26.53 106.27l-2 1.2z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.47 1262.74 1.2 2-2 1.2a77.46 77.46 0 0 1 -106.28-26.54l-1.2-2 2-1.2a77.46 77.46 0 0 1 106.28 26.54z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.79 1198.32-1.19-2 2-1.2a77.46 77.46 0 0 1 106.28 26.54l1.2 2-2 1.2a77.47 77.47 0 0 1 -106.29-26.54z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.12 1088.85a77.44 77.44 0 0 1 -26.53 106.28l-2 1.2-1.2-2a77.47 77.47 0 0 1 26.54-106.29l2-1.19z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.37 241.81v-240h240c0 132.54-107.45 240-240 240z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.37 138.36v-136.55h136.22c0 75.41-60.99 136.55-136.22 136.55z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.37 64.47v-62.66h62.51a62.59 62.59 0 0 1 -62.51 62.66z",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m85.13 686.59-85.13-85.19 85.13-85.18 85.12 85.18z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.13 644.3-42.87-42.9 42.87-42.89 42.86 42.89z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.72 364.76-62.34-62.38 62.34-62.38 62.33 62.38z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.91 324.59h-44.39v-44.42h44.39z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.76 -1.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m670.07 151.67-2.69 72.33-72.33-2.69a72.37 72.37 0 0 1 -69.63-75l2.69-72.31 72.33 2.69a72.37 72.37 0 0 1 69.63 74.98z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.81 150.5a42.55 42.55 0 1 1 -85-3.16l1.58-42.52 42.52 1.58a42.54 42.54 0 0 1 40.9 44.1z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.44 195.42-1.07 28.93-28.93-1.07a43.43 43.43 0 0 1 -41.79-45l1.08-28.93 28.93 1.08a43.42 43.42 0 0 1 41.78 44.99z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.63 1181.92v-79.6h79.6a80.42 80.42 0 0 1 80.42 80.41v79.61h-79.65a80.42 80.42 0 0 1 -80.37-80.42z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.2 1182.33a47 47 0 0 1 94.09 0v47h-47.05a47 47 0 0 1 -47.04-47z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.63 1133.92v-32h32a48 48 0 0 1 48 48v32h-32a48 48 0 0 1 -48-48z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.84 575.58a57.56 57.56 0 0 1 0-115.12h57.56v57.54a57.56 57.56 0 0 1 -57.56 57.58z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682 529.3a34.42 34.42 0 0 1 0-68.84h34.4v34.42a34.42 34.42 0 0 1 -34.4 34.42z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.84 553.74a35.14 35.14 0 1 1 35.16-35.14 35.14 35.14 0 0 1 -35.16 35.14z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.84 539.17a20.57 20.57 0 1 1 20.57-20.57 20.57 20.57 0 0 1 -20.57 20.57z",
    opacity: 0.06
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternPricing1);
export default __webpack_public_path__ + "static/media/pattern_pricing1.221688e02b07a2b3fd0453126ff154d4.svg";
export { ForwardRef as ReactComponent };